import React, { useState, useEffect, useContext } from "react";
import AdminContext from "../../../StateContext/Application";
import { apiurl } from "../../../../../path";
import {
  PDF32,
  Time32,
  UpdateWhite32,
  Excel32,
  JPG32,
  PNG32,
  AddFile32,
  VendorName32,
  Bank32,
  barely_black_bg_img,
  Cancel32,
  Email32,
  Location32,
  PhoneNumber32,
  submit,
} from "../../../../../public/LoginImages/importimages";

const AgencyOutwardList = () => {
  const context = useContext(AdminContext);
  const { GetAgencyList } = context;
  const [Agency, setAgencyList] = useState([]);
  const [filteredBills, setFilteredBills] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const billsPerPage = 10;
  const [searchTerm, setSearchTerm] = useState("");

  const totalPages = Math.ceil((filteredBills?.length || 0) / billsPerPage);
  const indexOfLastBill = currentPage * billsPerPage;
  const indexOfFirstBill = indexOfLastBill - billsPerPage;
  const currentBills = Array.isArray(filteredBills)
    ? filteredBills.slice(indexOfFirstBill, indexOfLastBill)
    : [];

  // const getAgencyList = async () => {
  //   let data = await GetAgencyList();
  //   setAgencyList(data || []);
  //   setFilteredBills(data || []);
  // };
  // 22-09 
  const getAgencyList = async () => {
    let data = await GetAgencyList();
 
    // const sortedData = (data || []).sort((a, b) => {
    //     return new Date(b.Date) - new Date(a.Date);
    // });
    // 29-09 sorting data
     const sortedData = [...(data || [])].reverse();
 
    setAgencyList(sortedData);
    setFilteredBills(sortedData);
 
 
    setAgencyList(sortedData);
    setFilteredBills(sortedData);
};

  useEffect(() => {
    getAgencyList();
  }, []);

  let AgencyList = [];
  if (Agency.length > 0) {
    AgencyList = Agency;
  }

  useEffect(() => {
    const lowerSearchTerm = searchTerm.toLowerCase();
    const filtered = Agency.filter((bill) =>
      Object.values(bill).some((val) =>
        (val || "").toString().toLowerCase().includes(lowerSearchTerm),
      ),
    );
    setFilteredBills(filtered);
    setCurrentPage(1); // Reset to page 1 on search
  }, [searchTerm, Agency]);

  const getAgencyInwardPageNumbers = () => {
    const maxVisiblePages = 5;

    if (totalPages <= maxVisiblePages) {
      return Array.from({ length: totalPages }, (_, index) => index + 1);
    }

    // Starting pages
    // 1 2 3 4 5 ... Last
    if (currentPage <= 3) {
      return [1, 2, 3, 4, 5, "...", totalPages];
    }

    // Last pages
    // ... 16 17 18 19 20
    if (currentPage >= totalPages - 2) {
      return [
        "...",
        totalPages - 4,
        totalPages - 3,
        totalPages - 2,
        totalPages - 1,
        totalPages,
      ];
    }

    // Middle pages
    // ... 4 5 6 7 8 ... 20
    return [
      "...",
      currentPage - 2,
      currentPage - 1,
      currentPage,
      currentPage + 1,
      currentPage + 2,
      "...",
      totalPages,
    ];
  };

  return (
    //30/10
    <div
      style={{
        background: "white",
        width: "90%",
      marginLeft:"40px",
        maxHeight: "89vh",
        // padding:"20px",
        // padding: 20,
        fontFamily: "Inter, sans-serif",
      marginBottom:"20px",
      msOverflowStyle: "none",
          scrollbarWidth: "none",
      }}
    >
      {/* //30/10 */}
        <div
  className="col-12 m-auto my-5 budgetContainer"
  style={{
    border: "1px solid #d5dce5",
    borderRadius: "12px",
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.12)",
    backgroundColor: "#eef2f8",
    padding: "20px",
    boxSizing: "border-box",
  }}
>
  {/* //30/10 */}
     <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 10,
            padding: "0 20px",
            width: "100%",
          }}
        >
          <h5
            style={{
              fontWeight: "bold",
              color: "black",
              display: "flex",
              alignItems: "center",
            }}
          >
            <img
              src={"/List-32.png"}
              alt="icon"
              style={{ marginRight: 10, width: 28, height: 28 }}
            />
            Agency List
          </h5>
          <div
            style={{
              display: "flex",
              alignItems: "center",
                  backgroundColor:"white",
              border: "1px solid #ccc",
              borderRadius: 5,
              padding: "5px 10px",
              width: 300,
            }}
          >
            <img
              src={"/Search-32.png"}
              alt="search"
              style={{ width: 20, height: 20, marginRight: 8 }}
            />
            <input
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Search Agency..."
              style={{
                border: "none",
                outline: "none",
                background: "transparent",
                width: "100%",
                fontSize: 14,
              }}
            />
          </div>
        </div>
      <div
        style={{
          display: "grid",
          justifyContent: "center",
          boxShadow: "0 0 10px rgba(0,0,0,0.1)",
          borderRadius: 10,
          //30/10
           backgroundColor: "white",
          padding: 20,
          maxHeight: "81vh",
          overflow: "auto",
        }}
      >
     
        
        <div style={{ position: "relative", width: "100%", minWidth: 0 }}>
 {/* //28/10 */}
  <div
  style={{
    overflowX: "auto",
    width: "100%",
    border: "1px solid #d9e1f2",  
    borderRadius: "8px",           
    boxSizing: "border-box",
  }}
>
 
          <table
            style={{
      backgroundColor: "white",
      width: "100%",
      minWidth: "70vw",
      borderCollapse: "separate",  
      borderSpacing: 0,            
    }}
          >
            <thead>
              <tr
              //28/10
                style={{
                  backgroundColor: "#2D79D9",
                  color: "white",
                  fontSize: 14,
                  fontWeight: 600,
                  textAlign: "left",
                  whiteSpace: "nowrap",
                }}
              >
                <th style={{ padding: 10 }}>Sr.No</th>
                <th style={{ padding: 10 }}>Unique Agency Code</th>
                <th style={{ padding: 10 }}>Agency Name</th>
                <th style={{ padding: 10 }}>Date</th>
                <th style={{ padding: 10 }}>Block/Building/Village</th>
                <th style={{ padding: 10 }}>Road/Street/Post Office</th>
                <th style={{ padding: 10 }}>Area/Locality</th>
                <th style={{ padding: 10 }}>City</th>
                <th style={{ padding: 10 }}>State</th>
                <th style={{ padding: 10 }}>District</th>
                <th style={{ padding: 10 }}>Pin Code</th>
                <th style={{ padding: 10 }}>Contact Person</th>
                <th style={{ padding: 10 }}>Designation</th>
                <th style={{ padding: 10 }}>Mobile No</th>
                <th style={{ padding: 10 }}>Email</th>
              </tr>
            </thead>
            {/* {currentBills?.map((Agency, index) => { */}
            {/* 01-10 */}
                 <tbody>
                {currentBills?.length > 0 ? currentBills.map((Agency, index) => {
 
              const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
              return (
           
                  <tr
                    key={index}
                    style={{
                      //28/10
                      backgroundColor: index % 2 === 0 ? "#E5F4FB" : "#CEE4F1",
                      fontSize: 13,
                      fontWeight: 500,
                      textAlign: "left",
                      whiteSpace: "break-spaces",
                    }}
                  >
                    <td style={{ padding: 10, border: "1px solid #b8cfe0", }}>
                      {indexOfFirstBill + index + 1}
                    </td>
                    <td style={{ padding: 10, color: "blue",textAlign:"center", border: "1px solid #b8cfe0",}}>{Agency.Unique_Agency_Code}</td>
                    <td style={{ padding: 10, border: "1px solid #b8cfe0",}}>{Agency.Agency_Name}</td>
                    <td style={{ padding: 10, whiteSpace: "nowrap",border: "1px solid #b8cfe0", }}>
                      <img
                        src={"/Time-32.png"}
                        style={{
                          marginRight: "5px",
                          width: "15px",
                          height: "15px",
                        }}
                      />
                      {Agency.Date?.split("T")[0].replace(" ")}
                    </td>
                    <td style={{ padding: 10, border: "1px solid #b8cfe0", }}>{Agency.Village}</td>
                    <td style={{ padding: 10,border: "1px solid #b8cfe0", }}>{Agency.Road}</td>
                    <td style={{ padding: 10 ,border: "1px solid #b8cfe0",}}>{Agency.Area}</td>
                    <td style={{ padding: 10, border: "1px solid #b8cfe0", }}>{Agency.City}</td>
                    <td style={{ padding: 10, border: "1px solid #b8cfe0", }}>{Agency.State}</td>
                    <td style={{ padding: 10, border: "1px solid #b8cfe0", }}>{Agency.District}</td>
                    <td style={{ padding: 10, border: "1px solid #b8cfe0", }}>{Agency.PinCode}</td>
                    <td style={{ padding: 10, border: "1px solid #b8cfe0", }}>{Agency.Contact_Person}</td>
                    <td style={{ padding: 10 ,border: "1px solid #b8cfe0", }}>{Agency.Designation}</td>
                    <td style={{ padding: 10 ,border: "1px solid #b8cfe0", }}>{Agency.Mobile_Number}</td>
                    <td style={{ padding: 10, border: "1px solid #b8cfe0", }}>{Agency.Email}</td>
                 </tr>
                               
                            )
                      }) : (
  <tr>
    {/* <td
      colSpan="15"
      style={{
        textAlign: "center",
        padding: "30px",
        fontSize: "15px",
        fontWeight: "600",
        color: "#777",
      }}  >
       
      No Data Available
    </td> */}
  </tr>
)}
</tbody>
          </table>
          {/* 22-10 */}
 {filteredBills.length === 0 && (
  <div
     style={{
        position: "sticky",
        left: 0,
        width: "100%",
        minWidth: "100%",
        height: "100px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#ffffff",
        color: "#555",
        fontSize: "14px",
        boxSizing: "border-box",
      }}>
    No Data Available
  </div>
)}
</div>

 
        </div>

        <div
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginTop: "15px",
            padding: "10px 5px",
            boxSizing: "border-box",
          }}
        >
          {/* Showing Entries */}
          <div
            style={{
              fontSize: "13px",
              color: "#333",
              whiteSpace: "nowrap",
            }}
          >
            Showing {filteredBills?.length === 0 ? 0 : indexOfFirstBill + 1} to{" "}
            {Math.min(indexOfLastBill, filteredBills?.length || 0)} of{" "}
            {filteredBills?.length || 0} entries
          </div>

          {/* Pagination */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "18px",
            }}
          >
            {/* Previous */}
            <button
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
              style={{
                border: "none",
                background: "transparent",
                color: "#2ea4e7",
                cursor: currentPage === 1 ? "not-allowed" : "pointer",
                fontSize: "12px",
                padding: 0,
                opacity: currentPage === 1 ? 0.5 : 1,
              }}
            >
              ‹ Previous
            </button>

            {/* Page Numbers */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "20px",
              }}
            >
              {getAgencyInwardPageNumbers().map((pageNumber, index) => {
                if (pageNumber === "...") {
                  return (
                    <span
                      key={`agency-dots-${index}`}
                      style={{
                        fontSize: "13px",
                        color: "#444",
                      }}
                    >
                      ...
                    </span>
                  );
                }

                return (
                  <button
                    key={pageNumber}
                    onClick={() => setCurrentPage(pageNumber)}
                    style={{
                      border: "none",
                      background: "transparent",
                      padding: 0,
                      color: currentPage === pageNumber ? "#2ea4e7" : "#444",
                      cursor: "pointer",
                      fontSize: "13px",
                      fontWeight: currentPage === pageNumber ? "600" : "400",
                      textDecoration:
                        currentPage === pageNumber ? "underline" : "none",
                    }}
                  >
                    {pageNumber}
                  </button>
                );
              })}
            </div>

            {/* Next */}
            <button
              onClick={() =>
                setCurrentPage((prev) => Math.min(prev + 1, totalPages))
              }
              disabled={currentPage === totalPages || totalPages === 0}
              style={{
                border: "none",
                background: "transparent",
                color: "#2ea4e7",
                cursor:
                  currentPage === totalPages || totalPages === 0
                    ? "not-allowed"
                    : "pointer",
                fontSize: "12px",
                padding: 0,
                opacity:
                  currentPage === totalPages || totalPages === 0 ? 0.5 : 1,
              }}
            >
              Next ›
            </button>
          </div>
        </div>
      </div>
      </div>
    </div>
  );
};

export default AgencyOutwardList;
